import { createFileRoute, redirect } from '@tanstack/react-router'
import { TgPreregister } from '#pages/common/tg-preregister'
import { CenteredLayout } from '#widgets/layouts/centered-layout'
import { getTgBotRole } from '#shared/lib/auth'
import { tgTokensQueryOptions } from '#shared/state/tg-tokens-query'

export const Route = createFileRoute('/staff/tg-preregister')({
  component: () => (
    <CenteredLayout>
      <TgPreregister />
    </CenteredLayout>
  ),

  loader: async ({ context }) => {
    const { queryClient } = context

    try {
      const botRole = getTgBotRole()
      await queryClient.fetchQuery(tgTokensQueryOptions)

      // Error don't happen, user is already registered
      throw redirect({ to: '/' + botRole })
    } catch {
      return
    }
  },
})
